import React from 'react'
import Placeholder from '../misc/placeholder'
import { getContributionStatus } from '../../helpers/api'
import { formatValueV2 } from '../../helpers/funcs'
import moment from 'moment';

const SectionContributions = props => {

    const [contributions, setContributions] = React.useState(null)

    const cycleId = props.cycleId || 2454; //default IRM

    React.useEffect(() => {
        getContributionStatus(props.Contributor.ContributorID, cycleId)
            .then(data => {
                setContributions(data)
            })
    }, []) //only on mount

    return contributions ? (
        <div className="table-responsive pl-3">
            <table className="table table-bordered table-striped table-sm">
                <thead className="bg-white">
                    {props.title && (
                        <tr className="bg-dark text-white">
                            <th colSpan="8">{props.title} - Status</th>
                        </tr>
                    )}
                    <tr>
                        <th className="text-center vertical-align-middle" rowSpan="2">Instrument</th>
                        <th className="text-center vertical-align-middle" rowSpan="2">Type</th>
                        <th className="text-center" colSpan="3">Announced</th>
                        <th className="text-center">Signed</th>
                        <th className="text-center">Disbursed Cash and Deposited PNs</th>
                        <th className="text-center">Pledged Amount at current FX</th>
                    </tr>
                    <tr>
                        <th colSpan="2" className="text-center">In Currency</th>
                        <th className="text-center">USD eq<sup>1</sup></th>
                        <th className="text-center">USD eq<sup>1</sup></th>
                        <th className="text-center">In Currency</th>
                        <th className="text-center">USD eq<sup>2</sup></th>
                    </tr>
                </thead>
                <tbody>
                    {contributions.length > 0 ? (
                        <React.Fragment>
                            {contributions.map((c, idx) => (
                                <tr key={idx}>
                                    <td>{c.Instrument}</td>
                                    <td>{c.Type}</td>
                                    <td>{c.Currency}</td>
                                    <td className="text-right">{c.Announced ? formatValueV2(c.Announced, '0,0') : '-'}</td>
                                    <td className="text-right">{c.AnnouncedUSD ? formatValueV2(c.AnnouncedUSD) : '-'}</td>
                                    <td className="text-right">{c.SignedUSD ? formatValueV2(c.SignedUSD) : '-'}</td>
                                    <td className="text-right">{c.Disbursed ? formatValueV2(c.Disbursed, '0,0') : '-'}</td>
                                    <td className="text-right">{c.DisbursedUSD ? formatValueV2(c.DisbursedUSD) : '-'}</td>
                                </tr>
                            ))}
                        </React.Fragment>
                    ) : (
                            <tr>
                                <td colSpan="8">No contribution data recorded ({props.title}).</td>
                            </tr>
                        )}

                </tbody>
                {contributions.length > 0 ? (
                    <tfoot>
                        <tr className="bg-secondary color-white font-weight-bold">
                            <td colSpan="3">Total</td>
                            <td className="text-right">{formatValueV2(contributions.reduce((acum, obj) => acum + obj.Announced, 0), '0,0')}</td>
                            <td className="text-right">{formatValueV2(contributions.reduce((acum, obj) => acum + obj.AnnouncedUSD, 0))}</td>
                            <td className="text-right">{formatValueV2(contributions.reduce((acum, obj) => acum + obj.SignedUSD, 0))}</td>
                            <td className="text-right">{formatValueV2(contributions.reduce((acum, obj) => acum + obj.Disbursed, 0), '0,0')}</td>
                            <td className="text-right">{formatValueV2(contributions.reduce((acum, obj) => acum + obj.DisbursedUSD, 0))}</td>
                        </tr>
                    </tfoot>
                ) : null}
            </table>
            <ul className="table-footnotes">
                <li><sup>1</sup> Based on the reference exchanges rates established for GCF's High-Level Pledging Conference.</li>
                <li><sup>2</sup> UN Operational Rates of Exchange. <a href="https://treasury.un.org/operationalrates/OperationalRates.php" rel="noopener noreferrer" target="_blank">United Nations Treasury</a>. {contributions.length && contributions[0].CurrencyEffectiveDate ? ''.concat('(', moment(contributions[0].CurrencyEffectiveDate).format('ll'), ')') : null}</li>
            </ul>
        </div>
    ) : <Placeholder />
}

export default SectionContributions